import React from "react"
import PropTypes from "prop-types"

function CaretUpIcon({ color = "#4F2170", width = "14", height = "12" }) {
    return (
        <svg width={width} height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.9891 11.4031C13.8246 11.8715 13.0011 11.654 12.3045 11.6046C11.9133 11.5766 9.26198 11.7074 8.87079 11.722C7.84056 11.7567 7.19212 11.7354 5.15868 11.742C3.90877 11.7461 4.40333 11.7074 3.15343 11.7127C2.90556 11.7127 2.29706 11.7888 1.34553 11.6433C1.07417 11.6019 0.124998 11.7914 0.0380688 11.5445C-0.151061 11.0067 0.404581 10.25 0.822783 9.66283C2.93023 6.70682 4.08733 4.85047 5.92459 1.72758C6.13135 1.37672 6.58596 0.220875 7.05585 0.0955C7.71722 -0.0807 7.95451 0.9496 8.20003 1.4033C9.06462 3.00479 9.94801 4.59957 10.8478 6.18501C11.8675 7.98131 14.1782 10.8613 13.9891 11.4031Z"
                fill={color}
            />
        </svg>
    )
}

CaretUpIcon.propTypes = {
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
}

export default CaretUpIcon
